var PES = PES || {};
PES.TrustPilot = function () {
    var trustPilotKey = "trust-pilot-data";
    var cacheDurationMs = 1000 * 60 * 60 * 24 * 7;
    var defaultScore = { TrustScore: 4.5, Stars: 4.5, TotalReviewers: 5489 }

    var setTrustPilotData = function (data) {
        $(".trust-score-anchor").html(data.TrustScore);
        $(".total-reviewers-anchor").html(data.TotalReviewers);
        //$(".current-star-rating > .stars").css("width", data.Stars * 20 + "%");
    };

    var trustPilotExists = function () {
        return ($(".total-reviewers-anchor").length && $(".trust-score-anchor").length) || $(".current-star-rating > .stars").length ;
    };

    var localStorageAvailable = function() {
        return typeof (Storage) !== "undefined";
    };

    var cacheExpired = function(timestamp) {
        if (timestamp) {
            var currentTime = (new Date()).getTime();
            return currentTime - timestamp > cacheDurationMs;
        } else {
            return true;
        }
    };

    var loadTrustScore = function (trustPilotUrl) {
        $.get(trustPilotUrl)
            .done(function (response) {
                setTrustPilotData(response);
                if (localStorageAvailable()) {
                    response.Timestamp = (new Date()).getTime();
                    localStorage.setItem(trustPilotKey, JSON.stringify(response));
                }
            })
            .fail(function () {
                setTrustPilotData(defaultScore);
            });
    };

    var init = function (trustPilotUrl) {
        if (trustPilotExists()) {
            if (localStorageAvailable()) {
                var trustScore = localStorage.getItem(trustPilotKey);
                if (trustScore) {
                    var data = JSON.parse(trustScore);
                    if (!cacheExpired(data.Timestamp)) {
                        setTrustPilotData(data);
                    } else {
                        loadTrustScore(trustPilotUrl);
                    }
                } else {
                    loadTrustScore(trustPilotUrl);
                }
            } else {
                loadTrustScore(trustPilotUrl);
            }
        }
    };

    return {
        init: init
    };
}();